import { FileText, Sparkles } from 'lucide-react';

export default function Terms() {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-wrapper" style={{ paddingBottom: '4rem' }}>
        <div className="grid-2">
          <div>
            <span className="section-label">
              <Sparkles size={14} style={{ marginRight: '0.4rem', verticalAlign: 'middle' }} />
              Terms of Service
            </span>
            <h1 className="hero-gradient-text" style={{ fontSize: '3rem' }}>
              Terms and conditions for using Roriri
            </h1>
            <p className="section-desc" style={{ fontSize: '1.2rem', marginBottom: '2.5rem' }}>
              Read the terms that govern access to and use of our school ERP platform.
            </p>
          </div>

          <div className="hero-mockup-wrapper" style={{ padding: '2rem' }}>
            <div className="premium-card" style={{ padding: '2rem', display: 'flex', gap: '1.5rem', alignItems: 'center', margin: 0 }}>
              <div className="icon-box" style={{ margin: 0, flexShrink: 0 }}>
                <FileText size={32} />
              </div>
              <div>
                <h3 style={{ fontSize: '1.2rem', marginBottom: '0.25rem' }}>Legal Agreement</h3>
                <p style={{ margin: 0, fontSize: '0.95rem' }}>Your access to and use of the Roriri ERP platform is subject to compliance with these terms.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Terms Content Section */}
      <section style={{ borderTop: '1px solid var(--border-color)', borderBottom: '1px solid var(--border-color)', background: 'rgba(241, 245, 249, 0.2)' }}>
        <div className="section-wrapper">
          <div className="legal-container">
            <div className="legal-body-card">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing and using Roriri ("the Service"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>

              <h2>2. Description of Service</h2>
              <p>Roriri provides a cloud-based school management system that includes modules such as student management, attendance tracking, fee management, examination management, and related tools.</p>

              <h2>3. User Accounts</h2>
              <p>To use the Service, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. Notify us immediately if you suspect unauthorized use.</p>

              <h2>4. Payment Terms</h2>
              <p>Subscription fees are billed in advance monthly or annually. By providing payment information, you authorize us to charge the applicable fees. Refunds are provided according to our refund policy and fees are non-refundable except as required by law.</p>

              <h2>5. Data Privacy and Security</h2>
              <p>Your use of the Service is governed by our Privacy Policy. We use encryption and security best practices to protect your data, and you retain ownership of your information.</p>

              <h2>6. Acceptable Use</h2>
              <p>You agree not to use the Service for illegal purposes, attempt unauthorized access, disrupt the Service, transmit malware, or violate applicable laws or regulations.</p>

              <h2>7. Limitation of Liability</h2>
              <p>Roriri shall not be liable for indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the Service.</p>

              <h2>8. Termination</h2>
              <p>We may terminate or suspend your access immediately if you breach these Terms. Termination does not relieve you of unpaid fees.</p>

              <h2>9. Contact Information</h2>
              <p>
                For questions about these Terms, contact us at{' '}
                <a href="mailto:admin@roririsoft.com">admin@roririsoft.com</a>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
